export const SITE = {
  name: "Dr Lal PathLabs",
  tagline: "Collection Center • Bhopal",
  fullName: "Dr Lal PathLabs – Collection Center",
  city: "Bhopal",
  region: "Madhya Pradesh, India",
  phone: "8959830932",
  phoneIntl: "+918959830932",
  whatsappNumber: "918959830932",
  email: "lalpathlabsbhopal@outlook.com",
  defaultWaMessage:
    "Hello, I would like to enquire about diagnostic tests at Dr Lal PathLabs Collection Center, Bhopal.",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    message || SITE.defaultWaMessage
  )}`;

export const telLink = `tel:${SITE.phoneIntl}`;
export const mailLink = `mailto:${SITE.email}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtZWRpY2FsJTIwbGFib3JhdG9yeSUyMHNjaWVudGlzdHxlbnwwfHx8fDE3ODc2MzM4Njl8MA&ixlib=rb-4.1.0&q=85",
  homeCollection:
    "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxudXJzZSUyMHZpc2l0aW5nJTIwcGF0aWVudCUyMGhvbWV8ZW58MHx8fHwxNzg3NjMzODY5fDA&ixlib=rb-4.1.0&q=85",
  packages:
    "https://images.pexels.com/photos/14124346/pexels-photo-14124346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blood:
    "https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxibG9vZCUyMHRlc3QlMjBzYW1wbGUlMjB2aWFsc3xlbnwwfHx8fDE3ODc2MzM4Njl8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.unsplash.com/photo-1511174511562-5f7f18b874f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtZWRpY2FsJTIwbGFib3JhdG9yeSUyMHNjaWVudGlzdHxlbnwwfHx8fDE3ODc2MzM4Njl8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  { icon: "Droplet", title: "Blood Tests", desc: "Routine and specialized blood investigations." },
  { icon: "Activity", title: "Diabetes Testing", desc: "Laboratory investigations related to blood sugar monitoring." },
  { icon: "Gauge", title: "Thyroid Testing", desc: "Tests related to thyroid function." },
  { icon: "FlaskConical", title: "Liver Function Tests", desc: "Laboratory investigations related to liver function." },
  { icon: "Filter", title: "Kidney Function Tests", desc: "Tests used for assessment of kidney-related parameters." },
  { icon: "HeartPulse", title: "Lipid Profile", desc: "Testing related to cholesterol and lipid parameters." },
  { icon: "Sun", title: "Vitamin Tests", desc: "Enquire about available vitamin investigations." },
  { icon: "Waves", title: "Hormone Tests", desc: "Enquire about available hormone investigations." },
  { icon: "TestTubes", title: "Routine & Other Tests", desc: "Ask our collection center about available diagnostic investigations." },
];

export const TEST_CATEGORIES = [
  "Hematology",
  "Diabetes",
  "Thyroid",
  "Liver",
  "Kidney",
  "Lipid Profile",
  "Vitamins",
  "Hormones",
  "Urine & Routine",
  "Health Checkups",
];

export const TEST_LIST = [
  { name: "Complete Blood Count (CBC)", category: "Hematology", desc: "Routine blood investigation covering blood cell parameters." },
  { name: "Hemoglobin Test", category: "Hematology", desc: "Measures hemoglobin level in blood." },
  { name: "ESR", category: "Hematology", desc: "Erythrocyte sedimentation rate investigation." },
  { name: "Peripheral Smear", category: "Hematology", desc: "Microscopic examination of blood cells." },
  { name: "Blood Group & Rh Typing", category: "Hematology", desc: "Determines blood group and Rh factor." },
  { name: "Fasting Blood Sugar (FBS)", category: "Diabetes", desc: "Blood sugar measurement after fasting." },
  { name: "Postprandial Blood Sugar (PPBS)", category: "Diabetes", desc: "Blood sugar measurement after a meal." },
  { name: "HbA1c", category: "Diabetes", desc: "Reflects average blood sugar over a period of time." },
  { name: "Random Blood Sugar (RBS)", category: "Diabetes", desc: "Blood sugar measurement at any time of day." },
  { name: "Thyroid Profile (T3, T4, TSH)", category: "Thyroid", desc: "Panel of thyroid-related investigations." },
  { name: "TSH", category: "Thyroid", desc: "Thyroid stimulating hormone investigation." },
  { name: "Free T4", category: "Thyroid", desc: "Free thyroxine hormone investigation." },
  { name: "Liver Function Test (LFT)", category: "Liver", desc: "Panel of investigations related to liver function." },
  { name: "Bilirubin", category: "Liver", desc: "Bilirubin level investigation." },
  { name: "SGOT / SGPT", category: "Liver", desc: "Liver enzyme investigations." },
  { name: "Kidney Function Test (KFT)", category: "Kidney", desc: "Panel of investigations related to kidney function." },
  { name: "Serum Creatinine", category: "Kidney", desc: "Creatinine level investigation." },
  { name: "Blood Urea", category: "Kidney", desc: "Urea level investigation." },
  { name: "Lipid Profile", category: "Lipid Profile", desc: "Panel covering cholesterol and lipid parameters." },
  { name: "Total Cholesterol", category: "Lipid Profile", desc: "Cholesterol level investigation." },
  { name: "HDL / LDL Cholesterol", category: "Lipid Profile", desc: "Good and bad cholesterol parameters." },
  { name: "Vitamin D (25-OH)", category: "Vitamins", desc: "Vitamin D level investigation." },
  { name: "Vitamin B12", category: "Vitamins", desc: "Vitamin B12 level investigation." },
  { name: "Testosterone", category: "Hormones", desc: "Hormone level investigation." },
  { name: "Prolactin", category: "Hormones", desc: "Hormone level investigation." },
  { name: "FSH / LH", category: "Hormones", desc: "Hormone panel investigations." },
  { name: "Urine Routine & Microscopy", category: "Urine & Routine", desc: "Routine urine examination." },
  { name: "Urine Culture", category: "Urine & Routine", desc: "Urine culture investigation." },
];

export const PACKAGES = [
  { name: "Basic Health Checkup", desc: "Essential routine investigations for a general health overview." },
  { name: "Complete Health Checkup", desc: "A broader panel of investigations for a comprehensive overview." },
  { name: "Diabetes Checkup", desc: "Investigations focused on blood sugar monitoring." },
  { name: "Thyroid Checkup", desc: "Investigations related to thyroid function." },
  { name: "Heart Health Checkup", desc: "Investigations related to lipid and heart-health parameters." },
  { name: "Women's Health Checkup", desc: "Investigations curated for women's health needs." },
  { name: "Men's Health Checkup", desc: "Investigations curated for men's health needs." },
  { name: "Senior Citizen Checkup", desc: "Investigations suited for senior health monitoring." },
];

export const FAQS = [
  {
    q: "How can I book a diagnostic test?",
    a: "You can book by submitting the online enquiry form, calling 8959830932, or messaging us on WhatsApp. Our collection center team will contact you to confirm availability and appointment details.",
  },
  {
    q: "Can I request home sample collection?",
    a: "Yes. Contact the collection center to enquire about home sample collection availability in your area of Bhopal. Our team will confirm the applicable collection details.",
  },
  {
    q: "How can I know the price of a test?",
    a: "For current test prices and availability, please contact the collection center by phone, WhatsApp, or the enquiry form. Prices are not displayed online as they may change.",
  },
  {
    q: "Do I need an appointment?",
    a: "Please contact the center to confirm whether an appointment is required for your selected test or service. Booking in advance helps us serve you faster.",
  },
  {
    q: "How can I contact the collection center?",
    a: "Call 8959830932 or email lalpathlabsbhopal@outlook.com. You can also reach us on WhatsApp or through the contact form on this website.",
  },
  {
    q: "How can I enquire about health packages?",
    a: "You can enquire about available preventive health checkup packages by phone, WhatsApp, or the enquiry form. Our team will share current package details and availability.",
  },
  {
    q: "How will I receive my report?",
    a: "Report delivery arrangements depend on the applicable service and test. Please confirm the reporting channel with the collection center at the time of booking.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Tests", to: "/tests" },
  { label: "Health Packages", to: "/health-packages" },
  { label: "Home Collection", to: "/home-sample-collection" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
